// src/services/teacherSearchService.js
import api from './api'

export const searchService = {
	async search(query, filters = {}) {
		if (!query || query.length < 2) {
			return []
		}

		try {
			const response = await api.get('/teacher/search', {
				params: {
					q: query,
					...filters,
					limit: 10,
				},
			})
			const results = response?.results || response?.data?.results || []
			return Array.isArray(results) ? results : []
		} catch (error) {
			console.error('[TeacherSearchService] Search API error:', error)
			// Возвращаем пустой массив при ошибке
			return []
		}
	},

	async getTeacherStats() {
		if (typeof window !== 'undefined' && !localStorage.getItem('access_token')) {
			return { courses: 0, students: 0 }
		}
		try {
			// На бэкенде статистика находится в /api/v1/dashboard/stats
			// (старый /api/v1/teacher/stats на проде может отсутствовать)
			const response = await api.get('/dashboard/stats')
			const stats = response?.data || response
			return stats || { courses: 0, students: 0 }
		} catch (error) {
			return { courses: 0, students: 0 }
		}
	},
}
